import React from "react";

// Esqueletos com o mesmo formato do conteúdo final, para a tela não "pular" ao carregar.
const Bloco = ({ className = "" }) => <span className={`gm-esqueleto ${className}`.trim()} aria-hidden="true" />;

export const SkeletonProduto = () => (
  <div className="gm-esqueleto-produto" aria-hidden="true">
    <Bloco className="gm-esqueleto--foto" />
    <Bloco className="gm-esqueleto--linha" />
    <Bloco className="gm-esqueleto--linha gm-esqueleto--curta" />
  </div>
);

export const SkeletonRestaurante = () => (
  <div className="gm-esqueleto-restaurante" aria-hidden="true">
    <Bloco className="gm-esqueleto--logo" />
    <div className="gm-esqueleto-restaurante__texto">
      <Bloco className="gm-esqueleto--linha" />
      <Bloco className="gm-esqueleto--linha gm-esqueleto--curta" />
    </div>
  </div>
);

export const ListaSkeleton = ({ quantidade = 6, componente: Componente = SkeletonProduto, className = "" }) => (
  <div className={className} role="status" aria-label="Carregando">
    {Array.from({ length: quantidade }, (_, i) => (
      <Componente key={i} />
    ))}
  </div>
);
